import { FC } from 'react';
import { css, keyframes, useTheme } from '@emotion/react';

const rotateAnimation = keyframes`
  0% { transform: translate(0px, 0px); };
  100% { transform: translate(-38px, 0px); };
`;

const maskStyle = css`
  mask-type: alpha;

  > path,
  > g {
    transform: translate(0px, 0px);
  }
`;

const maskAnimatedStyle = css`
  > path,
  > g {
    animation: ${rotateAnimation} 7s infinite linear;
  }
`;

export const Flask: FC<{ size?: number; strokeWidth?: number; color?: string; animate?: boolean }> = ({
  size = 36,
  strokeWidth = 2.3,
  color = undefined,
  animate = false,
}) => {
  const theme = useTheme();
  if (!color) color = theme.color.grey[100];
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" width={size} height={size}>
      <path
        d="M14.625 4.5v8.6906a1.1816 1.1816 0 0 1-.1547.5766L5.5266 28.6734a1.1251 1.1251 0 0 0 .9562 1.7016h23.0344a1.1255 1.1255 0 0 0 .971-.5738 1.1249 1.1249 0 0 0-.0148-1.1278l-8.9437-14.9062a1.1806 1.1806 0 0 1-.1547-.5766V4.5M12.375 4.5h11.25"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="flask" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="5" y="14" width="26" height="17">
        <path
          d="M5.4206 28.9062 14.4547 14h7.1306l9.0341 14.9062a1.116 1.116 0 0 1 .0149 1.1278 1.1305 1.1305 0 0 1-.4125.4174 1.1455 1.1455 0 0 1-.5683.1564H6.3865a1.1454 1.1454 0 0 1-.5682-.1564 1.1304 1.1304 0 0 1-.4126-.4174 1.1157 1.1157 0 0 1 .015-1.1278Z"
          fill={color}
        />
      </mask>
      <g mask="url(#flask)" css={[maskStyle, animate && maskAnimatedStyle]}>
        <g opacity=".2" fill={color}>
          <path d="M-7 30.297v-8.2967c1.4896-.0134 3.3424.4051 5.6324 1.5467 4.0084 2.0098 6.681 1.7784 8.4115.9092.326-.1638 1.3916-1.3311 1.3916-1.3311.8461-.6238 2.013-1.1087 3.5645-1.1247 1.4896-.0134 3.3424.405 5.6324 1.5466 4.0084 2.0098 6.681 1.7784 8.4116.9092.326-.1638 1.3915-1.3311 1.3915-1.3311.8479-.6251 2.008-1.1108 3.5645-1.1248v8.2967H-7ZM31 30.297v-8.2967c1.4896-.0134 3.3424.4051 5.6324 1.5467 4.0084 2.0098 6.681 1.7784 8.4116.9092.326-.1638 1.3915-1.3311 1.3915-1.3311.8461-.6238 2.013-1.1087 3.5645-1.1247 1.4896-.0134 3.3424.405 5.6324 1.5466 4.0084 2.0098 6.681 1.7784 8.4116.9092.326-.1638 1.3915-1.3311 1.3915-1.3311.8479-.6251 2.008-1.1108 3.5645-1.1248v8.2967H31Z" />
        </g>
        <path
          d="M-7 22.0003c1.4896-.0134 3.3424.4051 5.6324 1.5467 4.0084 2.0098 6.681 1.7784 8.4115.9092.326-.1638 1.3916-1.3311 1.3916-1.3311.8461-.6238 2.013-1.1087 3.5645-1.1247 1.4896-.0134 3.3424.405 5.6324 1.5466 4.0084 2.0098 6.681 1.7784 8.4116.9092.326-.1638 1.3915-1.3311 1.3915-1.3311.8479-.6251 2.008-1.1108 3.5645-1.1248 1.4896-.0134 3.3424.4051 5.6324 1.5467 4.0084 2.0098 6.681 1.7784 8.4116.9092.326-.1638 1.3915-1.3311 1.3915-1.3311.8461-.6238 2.013-1.1087 3.5645-1.1247 1.4896-.0134 3.3424.405 5.6324 1.5466 4.0084 2.0098 6.681 1.7784 8.4116.9092.326-.1638 1.3915-1.3311 1.3915-1.3311.8479-.6251 2.008-1.1108 3.5645-1.1248"
          stroke={color}
          strokeWidth={strokeWidth}
        />
      </g>
    </svg>
  );
};
